import { z } from 'zod';
import { LocationAdapterKeySchema } from './location-adapter-registry.js';

const BaseResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

export const LocationAdapterAssignmentSchema = z.object({
  locationAdapterKey: LocationAdapterKeySchema,
  assignedAt: z.string().datetime(),
  assignedBy: z.string().min(1),
  notes: z.string().max(500).optional(),
});

export const PutLocationAdapterAssignmentBodySchema = z.object({
  locationAdapterKey: LocationAdapterKeySchema,
  notes: z.string().max(500).optional(),
});

export const LocationAdapterRegistryEntrySummarySchema = z.object({
  locationAdapterKey: z.string(),
  displayName: z.string(),
  thingGroupSuffix: z.string(),
  greengrassComponentName: z.string(),
  isDevSimulator: z.boolean().optional(),
});

export const LocationAdapterRegistryListResponseSchema = BaseResponseSchema.extend({
  data: z.object({ entries: z.array(LocationAdapterRegistryEntrySummarySchema) }),
});

export const LocationAdapterAssignmentResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    serialNumber: z.string(),
    assignment: LocationAdapterAssignmentSchema.nullable(),
  }),
});
// Inferred types
export type LocationAdapterAssignment = z.infer<typeof LocationAdapterAssignmentSchema>;
export type LocationAdapterAssignmentResponse = z.infer<typeof LocationAdapterAssignmentResponseSchema>;
export type LocationAdapterRegistryEntrySummary = z.infer<typeof LocationAdapterRegistryEntrySummarySchema>;
export type LocationAdapterRegistryListResponse = z.infer<typeof LocationAdapterRegistryListResponseSchema>;
export type PutLocationAdapterAssignmentBody = z.infer<typeof PutLocationAdapterAssignmentBodySchema>;
